export const selectCurrentModal = ({ core: { currentModal } }) => currentModal;

export default {
  selectCurrentModal,
};
